import { API2_HOST } from '@/utils/constants';
import { VipNoticeStatus } from '@/utils/pageConfig/settings/vipNotice';

import request from './request';
import { IBaseResponse } from './types/common';

// 查询Vip专属通知开关状态
export const getVipNoticeStatus = () => {
  const url = `${API2_HOST}/notification-site/v1/private/vip/get_vip_subscribe`;
  return new Promise<{ result: VipNoticeStatus }>((resolve, reject) => {
    request
      .post<IBaseResponse<VipNoticeStatus>>(url)
      .then((response) => {
        resolve(response.result as unknown as { result: VipNoticeStatus });
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
};

export const setVipNoticeStatus = (status: VipNoticeStatus) => {
  const url = `${API2_HOST}/notification-site/v1/private/vip/set_vip_subscribe`;
  return new Promise((resolve, reject) => {
    request
      .post<IBaseResponse<VipNoticeStatus>>(url, {
        body: JSON.stringify({ status }),
      })
      .then((response) => {
        resolve(response.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
};
